import axios from 'axios'
import { catchError } from '../../utils/CatchError/CatchError'
import { apiService } from '../_config_/apiservice'

// Erros de validação da logo (formato, tamanho, dimensão) chegam como
// [{ msgUsuario, msgDesenvolvedor }] — a orientação é acionável, então vale mostrá-la
// em vez do genérico do catchError().
const erroLogo = (error: unknown): { message: string } => {
  if (axios.isAxiosError(error)) {
    const data = error.response?.data
    const msg = Array.isArray(data) ? data[0]?.msgUsuario : undefined
    if (msg) {
      return { message: msg }
    }
  }
  return catchError(error)
}

export const uploadLogoOrganizacao = async (
  id: number,
  arquivo: File
): Promise<GetOrganizacaoLogoType | { message: string }> => {
  const formData = new FormData()
  formData.append('multipartFile', arquivo)
  try {
    const result = await apiService.post(
      `central/organizacao/${id}/logo`,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    )
    if (result.status === 200) {
      return result.data
    }
  } catch (error) {
    return erroLogo(error)
  }
  return {
    message: 'Algo de errado aconteceu!',
  }
}

// Devolve o binário da logo, ou null quando a organização ainda não tem uma cadastrada
// (a API responde 204 nesse caso — ausência é estado normal, não erro de tela).
export const getLogoOrganizacao = async (
  id: number
): Promise<Blob | null | { message: string }> => {
  try {
    const result = await apiService.get(`central/organizacao/${id}/logo`, {
      responseType: 'blob',
    })
    if (result.status === 204) {
      return null
    }
    if (result.status === 200) {
      return result.data
    }
  } catch (error) {
    return catchError(error)
  }
  return {
    message: 'Algo de errado aconteceu!',
  }
}

export const deleteLogoOrganizacao = async (
  id: number
): Promise<{ info: string } | { message: string }> => {
  try {
    const result = await apiService.delete(`central/organizacao/${id}/logo`)
    if (result.status === 200) {
      return { info: 'Logo removida.' }
    }
  } catch (error) {
    return erroLogo(error)
  }
  return {
    message: 'Algo de errado aconteceu!',
  }
}
